import { render, staticRenderFns } from "./SubDesignationCreateModal.vue?vue&type=template&id=0af2ae88"
import script from "./SubDesignationCreateModal.vue?vue&type=script&lang=js"
export * from "./SubDesignationCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports